import type { TagDto } from './tag'

export type FirearmModelStatus = 0 | 1 | 2; // Pending, Approved, Rejected

/** API uses JsonStringEnumConverter; normalize wire values to numeric status. */
const FIREARM_MODEL_STATUS_FROM_API: Record<string, FirearmModelStatus> = {
  Pending: 0,
  Approved: 1,
  Rejected: 2
}

export function normalizeFirearmModelStatus (
  status: FirearmModelStatus | string | number | undefined | null
): FirearmModelStatus | undefined {
  if (status === 0 || status === 1 || status === 2) return status
  if (typeof status === 'string') {
    return FIREARM_MODEL_STATUS_FROM_API[status]
  }
  return undefined
}

export function normalizeFirearmModel (model: FirearmModel): FirearmModel {
  const status = normalizeFirearmModelStatus(model.status)
  return status === undefined ? model : { ...model, status }
}

export interface FirearmModel {
  id: string;
  make: string;
  model: string;
  platform: string | null;
  caliber: string | null;
  actionType: string | null;
  yearIntroduced: number | null;
  description: string | null;
  coverImageUrl: string | null;
  status: FirearmModelStatus;
  isVerified: boolean;
  submittedByUsername: string | null;
  submittedByDisplayName: string | null;
  createdAt: string;
  approvedAt: string | null;
  voteScore: number;
  currentUserVote: number | null;
  buildCount?: number;
  tags?: TagDto[];
}

export interface FirearmModelFormValues {
  make: string;
  model: string;
  platform?: string;
  caliber?: string;
  actionType?: string;
  yearIntroduced?: number | null;
  description?: string;
  coverImageUrl?: string;
}
